import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {User, UserRole} from '../../../../core/models/user';
import {AuthUser, TokenService} from '../../../../core/auth';
import {UserService} from '../../../../core/services/user.service';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {SelectItem} from 'primeng/api';
import {EventService} from '../../../../core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-user-creation',
  templateUrl: './user-creation.page.html',
  styleUrls: ['./user-creation.page.css'],
})
export class UserCreationPage implements OnInit {
  @Input() user: User;
  userOrig: User;
  form: FormGroup;
  saving = false;
  loading = false;
  authUser: AuthUser = this.token.whoAmI();
  availableUserRolesSelect: SelectItem[] = [
    {label: 'Select Role', value: null},
  ];
  selectedUserRole: string;

  constructor(
    private userService: UserService,
    private router: Router,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService,
    private eventService: EventService,
    private formBuilder: FormBuilder
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin']},
      {label: 'user', routerLink: ['/admin', 'user', 'list']},
      {label: 'new'},
    ]);
  }

  ngOnInit() {
    this.user = {} as User;
    this.userService.getAvailableRoles().subscribe((data) => {
      data.forEach((role) =>
        this.availableUserRolesSelect.push({
          label: role.name,
          value: role.name,
        })
      );
      this.loadForm();
    });
  }

  loadForm() {
    this.form = this.formBuilder.group(
      {
        userName: ['', Validators.required],
        userEmail: ['', [Validators.required, Validators.email]],
        selectedUserRole: ['', Validators.required],
      }
    );
  }

  backToList() {
    this.router.navigate(['/admin', 'user', 'list']);
  }

  saveUser() {
    // copy the form values to the corresponding user field
    this.saving = true;
    this.user.name = this.form.controls.userName.value;
    this.user.email = this.form.controls.userEmail.value;
    this.user.userRole = {} as UserRole;
    this.user.userRole.name = this.form.controls.selectedUserRole.value;

    this.createUser();
  }

  createUser() {
    this.userService.create(this.user).subscribe(
      (data) => {
        this.backToList();
        delete this.saving;
      },
      (error) => {
        delete this.saving;
      }
    );
  }
}
